import React from "react";
import { Link } from "react-router-dom";

function Profile() {
  return (
    <div>
      <div className="loader" />
      <div id="app">
        <div className="main-wrapper main-wrapper-1">
          <div className="navbar-bg" />
          <nav className="navbar navbar-expand-lg main-navbar sticky">
            <div className="form-inline mr-auto">
              <ul className="navbar-nav mr-3">
                <li>
                  <a
                    href="#"
                    data-toggle="sidebar"
                    className="nav-link nav-link-lg
									collapse-btn"
                  >
                    {" "}
                    <i data-feather="align-justify" />
                  </a>
                </li>
                <li>
                  <a href="#" className="nav-link nav-link-lg fullscreen-btn">
                    <i data-feather="maximize" />
                  </a>
                </li>
                <li>
                  <form className="form-inline mr-auto">
                    <div className="search-element">
                      <input
                        className="form-control"
                        type="search"
                        placeholder="Search"
                        aria-label="Search"
                        data-width={200}
                      />
                      <button className="btn" type="submit">
                        <i className="fas fa-search" />
                      </button>
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <ul className="navbar-nav navbar-right">
              <li className="dropdown dropdown-list-toggle">
                <a
                  href="#"
                  data-toggle="dropdown"
                  className="nav-link nav-link-lg message-toggle"
                >
                  <i data-feather="mail" />
                  <span className="badge headerBadge1">6 </span>{" "}
                </a>
                <div className="dropdown-menu dropdown-list dropdown-menu-right pullDown">
                  <div className="dropdown-header">
                    Messages
                    <div className="float-right">
                      <a href="#">Mark All As Read</a>
                    </div>
                  </div>
                  <div className="dropdown-list-content dropdown-list-message">
                    <a href="#" className="dropdown-item">
                      {" "}
                      <span
                        className="dropdown-item-avatar
											text-white"
                      >
                        {" "}
                        <img
                          alt="image"
                          src="assets/img/users/user-1.png"
                          className="rounded-circle"
                        />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        <span className="message-user">Hero Gaur</span>
                        <span className="time messege-text">
                          Please check your mail !!
                        </span>
                        <span className="time">2 Min Ago</span>
                      </span>
                    </a>{" "}
                    <a href="#" className="dropdown-item">
                      {" "}
                      <span className="dropdown-item-avatar text-white">
                        <img
                          alt="image"
                          src="assets/img/users/user-2.png"
                          className="rounded-circle"
                        />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        <span className="message-user">Sarah Smith</span>{" "}
                        <span className="time messege-text">
                          Request for leave application
                        </span>
                        <span className="time">5 Min Ago</span>
                      </span>
                    </a>{" "}
                    <a href="#" className="dropdown-item">
                      {" "}
                      <span className="dropdown-item-avatar text-white">
                        <img
                          alt="image"
                          src="assets/img/users/user-5.png"
                          className="rounded-circle"
                        />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        <span className="message-user">Jacob Ryan</span>{" "}
                        <span className="time messege-text">
                          Your payment invoice is generated.
                        </span>{" "}
                        <span className="time">12 Min Ago</span>
                      </span>
                    </a>{" "}
                    <a href="#" className="dropdown-item">
                      {" "}
                      <span className="dropdown-item-avatar text-white">
                        <img
                          alt="image"
                          src="assets/img/users/user-4.png"
                          className="rounded-circle"
                        />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        <span className="message-user">Lina Smith</span>{" "}
                        <span className="time messege-text">
                          hii Hero, I have upload doc related to task.
                        </span>{" "}
                        <span className="time">30 Min Ago</span>
                      </span>
                    </a>{" "}
                    <a href="#" className="dropdown-item">
                      {" "}
                      <span className="dropdown-item-avatar text-white">
                        <img
                          alt="image"
                          src="assets/img/users/user-3.png"
                          className="rounded-circle"
                        />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        <span className="message-user">Jalpa Joshi</span>{" "}
                        <span className="time messege-text">
                          Please do as specify. Let me know if you have any
                          query.
                        </span>{" "}
                        <span className="time">1 Days Ago</span>
                      </span>
                    </a>{" "}
                    <a href="#" className="dropdown-item">
                      {" "}
                      <span className="dropdown-item-avatar text-white">
                        <img
                          alt="image"
                          src="assets/img/users/user-2.png"
                          className="rounded-circle"
                        />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        <span className="message-user">Sarah Smith</span>{" "}
                        <span className="time messege-text">
                          Client Requirements
                        </span>
                        <span className="time">2 Days Ago</span>
                      </span>
                    </a>
                  </div>
                  <div className="dropdown-footer text-center">
                    <a href="#">
                      View All <i className="fas fa-chevron-right" />
                    </a>
                  </div>
                </div>
              </li>
              <li className="dropdown dropdown-list-toggle">
                <a
                  href="#"
                  data-toggle="dropdown"
                  className="nav-link notification-toggle nav-link-lg"
                >
                  <i data-feather="bell" className="bell" />
                </a>
                <div className="dropdown-menu dropdown-list dropdown-menu-right pullDown">
                  <div className="dropdown-header">
                    Notifications
                    <div className="float-right">
                      <a href="#">Mark All As Read</a>
                    </div>
                  </div>
                  <div className="dropdown-list-content dropdown-list-icons">
                    <a href="#" className="dropdown-item dropdown-item-unread">
                      {" "}
                      <span className="dropdown-item-icon bg-primary text-white">
                        {" "}
                        <i
                          className="fas
												fa-code"
                        />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        Template update is available now!{" "}
                        <span className="time">2 Min Ago</span>
                      </span>
                    </a>{" "}
                    <a href="#" className="dropdown-item">
                      {" "}
                      <span className="dropdown-item-icon bg-info text-white">
                        {" "}
                        <i
                          className="far
												fa-user"
                        />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        <b>You</b> and <b>Dedik Sugiharto</b> are now friends{" "}
                        <span className="time">10 Hours Ago</span>
                      </span>
                    </a>{" "}
                    <a href="#" className="dropdown-item">
                      {" "}
                      <span className="dropdown-item-icon bg-success text-white">
                        {" "}
                        <i
                          className="fas
												fa-check"
                        />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        <b>Kusnaedi</b> has moved task <b>Fix bug header</b> to{" "}
                        <b>Done</b> <span className="time">12 Hours Ago</span>
                      </span>
                    </a>{" "}
                    <a href="#" className="dropdown-item">
                      {" "}
                      <span className="dropdown-item-icon bg-danger text-white">
                        {" "}
                        <i className="fas fa-exclamation-triangle" />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        Low disk space. Let's clean it!{" "}
                        <span className="time">17 Hours Ago</span>
                      </span>
                    </a>{" "}
                    <a href="#" className="dropdown-item">
                      {" "}
                      <span className="dropdown-item-icon bg-info text-white">
                        {" "}
                        <i
                          className="fas
												fa-bell"
                        />
                      </span>{" "}
                      <span className="dropdown-item-desc">
                        {" "}
                        Welcome to HR template!{" "}
                        <span className="time">Yesterday</span>
                      </span>
                    </a>
                  </div>
                  <div className="dropdown-footer text-center">
                    <a href="#">
                      View All <i className="fas fa-chevron-right" />
                    </a>
                  </div>
                </div>
              </li>
              <li className="dropdown">
                <a
                  href="#"
                  data-toggle="dropdown"
                  className="nav-link dropdown-toggle nav-link-lg nav-link-user"
                >
                  {" "}
                  <img
                    alt="image"
                    src="assets/img/user.png"
                    className="user-img-radious-style"
                  />{" "}
                  <span className="d-sm-none d-lg-inline-block" />
                </a>
                <div className="dropdown-menu dropdown-menu-right pullDown">
                  <div className="dropdown-title">Hello Sarah Smith</div>
                  <Link to="/profile" className="dropdown-item has-icon">
                    {" "}
                    <i
                      className="far
										fa-user"
                    />{" "}
                    Profile
                  </Link>{" "}
                  <a href="timeline.html" className="dropdown-item has-icon">
                    {" "}
                    <i className="fas fa-bolt" />
                    Activities
                  </a>{" "}
                  <a href="#" className="dropdown-item has-icon">
                    {" "}
                    <i className="fas fa-cog" />
                    Settings
                  </a>
                  <div className="dropdown-divider" />
                  <a
                    href="auth-login.html"
                    className="dropdown-item has-icon text-danger"
                  >
                    {" "}
                    <i className="fas fa-sign-out-alt" />
                    Logout
                  </a>
                </div>
              </li>
            </ul>
          </nav>
          <div className="main-sidebar sidebar-style-2">
            <aside id="sidebar-wrapper">
              <div className="sidebar-brand">
                <Link to="/adminhome">
                  {" "}
                  <img
                    alt="image"
                    src="assets/img/logo.png"
                    className="header-logo"
                  />{" "}
                  <span className="logo-name">HR</span>
                </Link>
              </div>
              <ul className="sidebar-menu">
                <li className="menu-header">Main</li>
                <li className="dropdown active">
                  <Link to="/adminhome" className="nav-link">
                    <i data-feather="monitor" />
                    <span>Dashboard</span>
                  </Link>
                </li>

                <li className="dropdown">
                  <a href="#" className="menu-toggle nav-link has-dropdown">
                    <i data-feather="shopping-bag" />
                    <span>Advanced</span>
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="nav-link" href="avatar.html">
                        Avatar
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="card.html">
                        Card
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="modal.html">
                        Modal
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="sweet-alert.html">
                        Sweet Alert
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="toastr.html">
                        Toastr
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="empty-state.html">
                        Empty State
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="multiple-upload.html">
                        Multiple Upload
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="pricing.html">
                        Pricing
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="tabs.html">
                        Tab
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="menu-header">Media</li>
                <li className="dropdown">
                  <a href="#" className="menu-toggle nav-link has-dropdown">
                    <i data-feather="image" />
                    <span>Gallery</span>
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="nav-link" to="/lightgallery">
                        Light Gallery
                      </Link>
                    </li>
                    <li>
                      <Link to="/gallery">Gallery 2</Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown">
                  <a href="#" className="menu-toggle nav-link has-dropdown">
                    <i data-feather="anchor" />
                    <span>Other Pages</span>
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="nav-link" href="create-post.html">
                        Create Post
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="posts.html">
                        Posts
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="profile.html">
                        Profile
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="contact.html">
                        Contact
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="invoice.html">
                        Invoice
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </aside>
          </div>
          <div className="main-content">
            <section className="section">
              <div className="section-body">
                <div className="row mt-sm-4">
                  <div className="col-12 col-md-12 col-lg-4">
                    <div className="card author-box">
                      <div className="card-body">
                        <div className="author-box-center">
                          <img
                            alt="image"
                            src="assets/img/users/user-1.png"
                            className="rounded-circle author-box-picture"
                          />
                          <div className="clearfix" />
                          <div className="author-box-name">
                            <a href="#">Hero Gaur</a>
                          </div>
                          <div className="author-box-job">Web Developer</div>
                        </div>
                        <div className="text-center">
                          <div className="author-box-description">
                            <p>
                              Digital Marketing Specialist | Front End Developer
                              | Content Writer | Freelancer
                            </p>
                          </div>
                          {/* <div className="mb-2 mt-3">
                            <div className="text-small font-weight-bold">
                              Follow Hasan On
                            </div>
                          </div> */}
                          <a
                            href="#"
                            className="btn btn-social-icon mr-1 btn-facebook"
                          >
                            <i className="fab fa-facebook-f" />
                          </a>
                          <a
                            href="#"
                            className="btn btn-social-icon mr-1 btn-twitter"
                          >
                            <i className="fab fa-twitter" />
                          </a>
                          <a
                            href="#"
                            className="btn btn-social-icon mr-1 btn-github"
                          >
                            <i className="fab fa-github" />
                          </a>
                          <a
                            href="#"
                            className="btn btn-social-icon mr-1 btn-instagram"
                          >
                            <i className="fab fa-instagram" />
                          </a>
                          <div className="w-100 d-sm-none" />
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <h4>Personal Details</h4>
                      </div>
                      <div className="card-body">
                        <div className="py-4">
                          <p className="clearfix">
                            <span className="float-left">Birthday</span>
                            <span className="float-right text-muted">
                              11-08-1998
                            </span>
                          </p>
                          <p className="clearfix">
                            <span className="float-left">Phone</span>
                            <span className="float-right text-muted">
                              (+91)7357268997
                            </span>
                          </p>
                          <p className="clearfix">
                            <span className="float-left">Mail</span>
                            <span className="float-right text-muted">
                              herogaur@gmail.com
                            </span>
                          </p>
                          <p className="clearfix">
                            <span className="float-left">Linkedin</span>
                            <span className="float-right text-muted">
                              <a
                                href="https://www.linkedin.com/in/herogaur/"
                                target="_hero"
                              >
                                Hero Gaur
                              </a>
                            </span>
                          </p>
                          <p className="clearfix">
                            <span className="float-left">Twitter</span>
                            <span className="float-right text-muted">
                              <a
                                href="https://twitter.com/hero_gaur"
                                target="_hero"
                              >
                                @hero_gaur
                              </a>
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <h4>Skills</h4>
                      </div>
                      <div className="card-body">
                        <ul className="list-unstyled user-progress list-unstyled-border list-unstyled-noborder">
                          <li className="media">
                            <div className="media-body">
                              <div className="media-title">Java</div>
                            </div>
                            <div className="media-progressbar p-t-10">
                              <div className="progress" data-height={6}>
                                <div
                                  className="progress-bar bg-primary"
                                  data-width="70%"
                                />
                              </div>
                            </div>
                          </li>
                          <li className="media">
                            <div className="media-body">
                              <div className="media-title">Web Design</div>
                            </div>
                            <div className="media-progressbar p-t-10">
                              <div className="progress" data-height={6}>
                                <div
                                  className="progress-bar bg-warning"
                                  data-width="80%"
                                />
                              </div>
                            </div>
                          </li>
                          <li className="media">
                            <div className="media-body">
                              <div className="media-title">Photoshop</div>
                            </div>
                            <div className="media-progressbar p-t-10">
                              <div className="progress" data-height={6}>
                                <div
                                  className="progress-bar bg-green"
                                  data-width="48%"
                                />
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-8">
                    <div className="card">
                      <div className="padding-20">
                        <ul className="nav nav-tabs" id="myTab2" role="tablist">
                          <li className="nav-item">
                            <a
                              className="nav-link active"
                              id="home-tab2"
                              data-toggle="tab"
                              href="#about"
                              role="tab"
                              aria-selected="true"
                            >
                              About
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              id="profile-tab2"
                              data-toggle="tab"
                              href="#settings"
                              role="tab"
                              aria-selected="false"
                            >
                              Setting
                            </a>
                          </li>
                        </ul>
                        <div
                          className="tab-content tab-bordered"
                          id="myTab3Content"
                        >
                          <div
                            className="tab-pane fade show active"
                            id="about"
                            role="tabpanel"
                            aria-labelledby="home-tab2"
                          >
                            <div className="row">
                              <div className="col-md-3 col-6 b-r">
                                <strong>Full Name</strong>
                                <br />
                                <p className="text-muted">Hero Gaur</p>
                              </div>
                              <div className="col-md-3 col-6 b-r">
                                <strong>Mobile</strong>
                                <br />
                                <p className="text-muted">+917357268997</p>
                              </div>
                              <div className="col-md-3 col-6 b-r">
                                <strong>Email</strong>
                                <br />
                                <p className="text-muted">hero@gmail.com</p>
                              </div>
                              <div className="col-md-3 col-6">
                                <strong>Location</strong>
                                <br />
                                <p className="text-muted">India</p>
                              </div>
                            </div>
                            <p className="m-t-30">
                              I can declare proudly that I am an experienced
                              expert Search Engine Optimizer with more than 6
                              years experience in both “On-Page” and “Off-Page”
                              Search Engine Optimization. I worked on 30+ live
                              projects And now the ranking of these keywords is
                              in the top 10. I have excellent experience in 10+
                              modules of digital marketing (SEO, Google ADS,
                              Webmaster, Keywords Planner, Content Creator,
                              Social Media Marketing, Search Engine Marketing,
                              ETC). I have 6 months of experience in front-end
                              developer and am now learning more skills. I'm
                              always interested in learning the best skills. I
                              have created more than 10 websites and also made
                              some software. I have worked as a front-end
                              developer and I have 10+ skills in front-end
                              developer (HTML, CSS, JavaScript, DOM
                              manipulation, JSON, AJAX, Node.js, MySQL, React,
                              Java, and web performance optimization)
                            </p>

                            <div className="section-title">Education</div>
                            <ul>
                              <li>12th., DPS, Haryana</li>
                              <li>B.A.,MD University, Haryana,India.</li>
                              <li>
                                M.A.,Kurukshetra University, Kurukshetra, India.
                              </li>
                            </ul>
                            <div className="section-title">Experience</div>
                            <ul>
                              <li>
                                8 Months Experience at IMT WEB MOK PVT
                                LTD(Scored A+ grade in Every Presentation in IMT
                                WEB MOK PVT LTD)
                              </li>
                              <li>3 Years’ Experience at Dricki IT Solution</li>
                              <li>2 Years Self-employed (Freelancer)</li>
                              <div className="section-title">
                                TECHNICAL (IT) SKILLS
                              </div>
                               HTML  CSS  Bootstrap  CSS Libraries 
                              JavaScript  JSON  jQuery  DOM Manipulation 
                              React JS  GIT  WEB Development  Search Engine
                              Optimization  Social Media Marketing  Social
                              Media Optimization  Mobile Marketing  Email –
                              Marketing  Webmaster  Google Analytic  MOZ 
                              Guest Posting  Content Creation
                            </ul>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="settings"
                            role="tabpanel"
                            aria-labelledby="profile-tab2"
                          >
                            <form method="post" className="needs-validation">
                              <div className="card-header">
                                <h4>Edit Profile</h4>
                              </div>
                              <div className="card-body">
                                <div className="row">
                                  <div className="form-group col-md-6 col-12">
                                    <label>First Name</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      defaultValue="Hero"
                                    />
                                    <div className="invalid-feedback">
                                      Please fill in the first name
                                    </div>
                                  </div>
                                  <div className="form-group col-md-6 col-12">
                                    <label>Last Name</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      defaultValue="Gaur"
                                    />
                                    <div className="invalid-feedback">
                                      Please fill in the last name
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="form-group col-md-7 col-12">
                                    <label>Email</label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      defaultValue="hero@gmail.com"
                                    />
                                    <div className="invalid-feedback">
                                      Please fill in the email
                                    </div>
                                  </div>
                                  <div className="form-group col-md-5 col-12">
                                    <label>Phone</label>
                                    <input
                                      type="tel"
                                      className="form-control"
                                      defaultValue="7357268997"
                                    />
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="form-group col-12">
                                    <label>Bio</label>
                                    <textarea
                                      className="form-control summernote-simple"
                                      defaultValue={
                                        "Digital Marketing Specialist | Full Stack Developer | Article Writer | Freelancer"
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="form-group mb-0 col-12">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        name="remember"
                                        className="custom-control-input"
                                        id="newsletter"
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="newsletter"
                                      >
                                        Subscribe to newsletter
                                      </label>
                                      <div className="text-muted form-text">
                                        You will get new information about
                                        products, offers and promotions
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="card-footer text-right">
                                <button className="btn btn-primary">
                                  Save Changes
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="settingSidebar">
              <a href="javascript:void(0)" className="settingPanelToggle">
                {" "}
                <i className="fa fa-spin fa-cog" />
              </a>
              <div className="settingSidebar-body ps-container ps-theme-default">
                <div className=" fade show active">
                  <div className="setting-panel-header">Setting Panel</div>
                  <div className="p-15 border-bottom">
                    <h6 className="font-medium m-b-10">Select Layout</h6>
                    <div className="selectgroup layout-color w-50">
                      <label className="selectgroup-item">
                        <input
                          type="radio"
                          name="value"
                          defaultValue={1}
                          className="selectgroup-input-radio select-layout"
                          defaultChecked
                        />
                        <span className="selectgroup-button">Light</span>
                      </label>
                      <label className="selectgroup-item">
                        <input
                          type="radio"
                          name="value"
                          defaultValue={2}
                          className="selectgroup-input-radio select-layout"
                        />
                        <span className="selectgroup-button">Dark</span>
                      </label>
                    </div>
                  </div>
                  <div className="p-15 border-bottom">
                    <h6 className="font-medium m-b-10">Sidebar Color</h6>
                    <div className="selectgroup selectgroup-pills sidebar-color">
                      <label className="selectgroup-item">
                        <input
                          type="radio"
                          name="icon-input"
                          defaultValue={1}
                          className="selectgroup-input select-sidebar"
                        />
                        <span
                          className="selectgroup-button selectgroup-button-icon"
                          data-toggle="tooltip"
                          data-original-title="Light Sidebar"
                        >
                          <i className="fas fa-sun" />
                        </span>
                      </label>
                      <label className="selectgroup-item">
                        <input
                          type="radio"
                          name="icon-input"
                          defaultValue={2}
                          className="selectgroup-input select-sidebar"
                          defaultChecked
                        />
                        <span
                          className="selectgroup-button selectgroup-button-icon"
                          data-toggle="tooltip"
                          data-original-title="Dark Sidebar"
                        >
                          <i className="fas fa-moon" />
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="p-15 border-bottom">
                    <h6 className="font-medium m-b-10">Color Theme</h6>
                    <div className="theme-setting-options">
                      <ul className="choose-theme list-unstyled mb-0">
                        <li title="white" className="active">
                          <div className="white" />
                        </li>
                        <li title="cyan">
                          <div className="cyan" />
                        </li>
                        <li title="black">
                          <div className="black" />
                        </li>
                        <li title="purple">
                          <div className="purple" />
                        </li>
                        <li title="orange">
                          <div className="orange" />
                        </li>
                        <li title="green">
                          <div className="green" />
                        </li>
                        <li title="red">
                          <div className="red" />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="p-15 border-bottom">
                    <div className="theme-setting-options">
                      <label className="m-b-0">
                        <input
                          type="checkbox"
                          name="custom-switch-checkbox"
                          className="custom-switch-input"
                          id="mini_sidebar_setting"
                        />
                        <span className="custom-switch-indicator" />
                        <span className="control-label p-l-10">
                          Mini Sidebar
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="p-15 border-bottom">
                    <div className="theme-setting-options">
                      <label className="m-b-0">
                        <input
                          type="checkbox"
                          name="custom-switch-checkbox"
                          className="custom-switch-input"
                          id="sticky_header_setting"
                        />
                        <span className="custom-switch-indicator" />
                        <span className="control-label p-l-10">
                          Sticky Header
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="mt-4 mb-4 p-3 align-center rt-sidebar-last-ele">
                    <a
                      href="#"
                      className="btn btn-icon icon-left btn-primary btn-restore-theme"
                    >
                      <i className="fas fa-und o" /> Restore Default
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Main Content */}
          <div className="main-content">
            <section className="section">
              <div className="row ">
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div className="card">
                    <div className="card-statistic-4">
                      <div className="align-items-center justify-content-between">
                        <div className="row ">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                            <div className="card-content">
                              <h5 className="font-15">New Booking</h5>
                              <h2 className="mb-3 font-18">258</h2>
                              <p className="mb-0">
                                <span className="col-green">10%</span> Increase
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                            <div className="banner-img">
                              <img src="assets/img/banner/1.png" alt />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div className="card">
                    <div className="card-statistic-4">
                      <div className="align-items-center justify-content-between">
                        <div className="row ">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                            <div className="card-content">
                              <h5 className="font-15"> Customers</h5>
                              <h2 className="mb-3 font-18">1,287</h2>
                              <p className="mb-0">
                                <span className="col-orange">09%</span> Decrease
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                            <div className="banner-img">
                              <img src="assets/img/banner/2.png" alt />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div className="card">
                    <div className="card-statistic-4">
                      <div className="align-items-center justify-content-between">
                        <div className="row ">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                            <div className="card-content">
                              <h5 className="font-15">New Project</h5>
                              <h2 className="mb-3 font-18">128</h2>
                              <p className="mb-0">
                                <span className="col-green">18%</span>
                                Increase
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                            <div className="banner-img">
                              <img src="assets/img/banner/3.png" alt />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div className="card">
                    <div className="card-statistic-4">
                      <div className="align-items-center justify-content-between">
                        <div className="row ">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                            <div className="card-content">
                              <h5 className="font-15">Revenue</h5>
                              <h2 className="mb-3 font-18">$48,697</h2>
                              <p className="mb-0">
                                <span className="col-green">42%</span> Increase
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                            <div className="banner-img">
                              <img src="assets/img/banner/4.png" alt />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-12 col-lg-12">
                  <div className="card ">
                    <div className="card-header">
                      <h4>Revenue chart</h4>
                      <div className="card-header-action">
                        <div className="dropdown">
                          <a
                            href="#"
                            data-toggle="dropdown"
                            className="btn btn-warning dropdown-toggle"
                          >
                            Options
                          </a>
                          <div className="dropdown-menu">
                            <a href="#" className="dropdown-item has-icon">
                              <i className="fas fa-eye" /> View
                            </a>
                            <a href="#" className="dropdown-item has-icon">
                              <i className="far fa-edit" /> Edit
                            </a>
                            <div className="dropdown-divider" />
                            <a
                              href="#"
                              className="dropdown-item has-icon text-danger"
                            >
                              <i className="far fa-trash-alt" />
                              Delete
                            </a>
                          </div>
                        </div>
                        <a href="#" className="btn btn-primary">
                          View All
                        </a>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-9">
                          <div id="chart1" />
                          <div className="row mb-0">
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                              <div className="list-inline text-center">
                                <div className="list-inline-item p-r-30">
                                  <i
                                    data-feather="arrow-up-circle"
                                    className="col-green"
                                  />
                                  <h5 className="m-b-0">$675</h5>
                                  <p className="text-muted font-14 m-b-0">
                                    Weekly Earnings
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                              <div className="list-inline text-center">
                                <div className="list-inline-item p-r-30">
                                  <i
                                    data-feather="arrow-down-circle"
                                    className="col-orange"
                                  />
                                  <h5 className="m-b-0">$1,587</h5>
                                  <p className="text-muted font-14 m-b-0">
                                    Monthly Earnings
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                              <div className="list-inline text-center">
                                <div className="list-inline-item p-r-30">
                                  <i
                                    data-feather="arrow-up-circle"
                                    className="col-green"
                                  />
                                  <h5 className="mb-0 m-b-0">$45,965</h5>
                                  <p className="text-muted font-14 m-b-0">
                                    Yearly Earnings
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="row mt-5">
                            <div className="col-7 col-xl-7 mb-3">
                              Total customers
                            </div>
                            <div className="col-5 col-xl-5 mb-3">
                              <span className="text-big">8,257</span>
                              <sup className="col-green">+09%</sup>
                            </div>
                            <div className="col-7 col-xl-7 mb-3">
                              Total Income
                            </div>
                            <div className="col-5 col-xl-5 mb-3">
                              <span className="text-big">$9,857</span>
                              <sup className="text-danger">-18%</sup>
                            </div>
                            <div className="col-7 col-xl-7 mb-3">
                              Project completed
                            </div>
                            <div className="col-5 col-xl-5 mb-3">
                              <span className="text-big">28</span>
                              <sup className="col-green">+16%</sup>
                            </div>
                            <div className="col-7 col-xl-7 mb-3">
                              Total expense
                            </div>
                            <div className="col-5 col-xl-5 mb-3">
                              <span className="text-big">$6,287</span>
                              <sup className="col-green">+09%</sup>
                            </div>
                            <div className="col-7 col-xl-7 mb-3">
                              New Customers
                            </div>
                            <div className="col-5 col-xl-5 mb-3">
                              <span className="text-big">684</span>
                              <sup className="col-green">+22%</sup>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-12 col-lg-4">
                  <div className="card">
                    <div className="card-header">
                      <h4>Chart</h4>
                    </div>
                    <div className="card-body">
                      <div id="chart4" className="chartsh" />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-lg-4">
                  <div className="card">
                    <div className="card-header">
                      <h4>Chart</h4>
                    </div>
                    <div className="card-body">
                      <div className="summary">
                        <div
                          className="summary-chart active"
                          data-tab-group="summary-tab"
                          id="summary-chart"
                        >
                          <div id="chart3" className="chartsh" />
                        </div>
                        <div
                          data-tab-group="summary-tab"
                          id="summary-text"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-lg-4">
                  <div className="card">
                    <div className="card-header">
                      <h4>Chart</h4>
                    </div>
                    <div className="card-body">
                      <div id="chart2" className="chartsh" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h4>Assign Task Table</h4>
                      <div className="card-header-form">
                        <form>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search"
                            />
                            <div className="input-group-btn">
                              <button className="btn btn-primary">
                                <i className="fas fa-search" />
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="card-body p-0">
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <tbody>
                            <tr>
                              <th className="text-center">
                                <div className="custom-checkbox custom-checkbox-table custom-control">
                                  <input
                                    type="checkbox"
                                    data-checkboxes="mygroup"
                                    data-checkbox-role="dad"
                                    className="custom-control-input"
                                    id="checkbox-all"
                                  />
                                  <label
                                    htmlFor="checkbox-all"
                                    className="custom-control-label"
                                  >
                                    &nbsp;
                                  </label>
                                </div>
                              </th>
                              <th>Task Name</th>
                              <th>Members</th>
                              <th>Task Status</th>
                              <th>Assigh Date</th>
                              <th>Due Date</th>
                              <th>Priority</th>
                              <th>Action</th>
                            </tr>
                            <tr>
                              <td className="p-0 text-center">
                                <div className="custom-checkbox custom-control">
                                  <input
                                    type="checkbox"
                                    data-checkboxes="mygroup"
                                    className="custom-control-input"
                                    id="checkbox-1"
                                  />
                                  <label
                                    htmlFor="checkbox-1"
                                    className="custom-control-label"
                                  >
                                    &nbsp;
                                  </label>
                                </div>
                              </td>
                              <td>Create a mobile app</td>
                              <td className="text-truncate">
                                <ul className="list-unstyled order-list m-b-0 m-b-0">
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-8.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Wildan Ahdian"
                                    />
                                  </li>
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-9.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Hero Gaur"
                                    />
                                  </li>
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-10.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Sarah Smith"
                                    />
                                  </li>
                                  <li className="avatar avatar-sm">
                                    <span className="badge badge-primary">
                                      +4
                                    </span>
                                  </li>
                                </ul>
                              </td>
                              <td className="align-middle">
                                <div className="progress-text">50%</div>
                                <div className="progress" data-height={6}>
                                  <div
                                    className="progress-bar bg-success"
                                    data-width="50%"
                                  />
                                </div>
                              </td>
                              <td>2018-01-20</td>
                              <td>2019-05-28</td>
                              <td>
                                <div className="badge badge-success">Low</div>
                              </td>
                              <td>
                                <a href="#" className="btn btn-outline-primary">
                                  Detail
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <td className="p-0 text-center">
                                <div className="custom-checkbox custom-control">
                                  <input
                                    type="checkbox"
                                    data-checkboxes="mygroup"
                                    className="custom-control-input"
                                    id="checkbox-2"
                                  />
                                  <label
                                    htmlFor="checkbox-2"
                                    className="custom-control-label"
                                  >
                                    &nbsp;
                                  </label>
                                </div>
                              </td>
                              <td>Redesign homepage</td>
                              <td className="text-truncate">
                                <ul className="list-unstyled order-list m-b-0 m-b-0">
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-1.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Wildan Ahdian"
                                    />
                                  </li>
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-2.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Hero Gaur"
                                    />
                                  </li>
                                  <li className="avatar avatar-sm">
                                    <span className="badge badge-primary">
                                      +2
                                    </span>
                                  </li>
                                </ul>
                              </td>
                              <td className="align-middle">
                                <div className="progress-text">40%</div>
                                <div className="progress" data-height={6}>
                                  <div
                                    className="progress-bar bg-danger"
                                    data-width="40%"
                                  />
                                </div>
                              </td>
                              <td>2017-07-14</td>
                              <td>2018-07-21</td>
                              <td>
                                <div className="badge badge-danger">High</div>
                              </td>
                              <td>
                                <a href="#" className="btn btn-outline-primary">
                                  Detail
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <td className="p-0 text-center">
                                <div className="custom-checkbox custom-control">
                                  <input
                                    type="checkbox"
                                    data-checkboxes="mygroup"
                                    className="custom-control-input"
                                    id="checkbox-3"
                                  />
                                  <label
                                    htmlFor="checkbox-3"
                                    className="custom-control-label"
                                  >
                                    &nbsp;
                                  </label>
                                </div>
                              </td>
                              <td>Backup database</td>
                              <td className="text-truncate">
                                <ul className="list-unstyled order-list m-b-0 m-b-0">
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-3.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Wildan Ahdian"
                                    />
                                  </li>
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-4.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Hero Gaur"
                                    />
                                  </li>
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-5.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Sarah Smith"
                                    />
                                  </li>
                                  <li className="avatar avatar-sm">
                                    <span className="badge badge-primary">
                                      +3
                                    </span>
                                  </li>
                                </ul>
                              </td>
                              <td className="align-middle">
                                <div className="progress-text">55%</div>
                                <div className="progress" data-height={6}>
                                  <div
                                    className="progress-bar bg-purple"
                                    data-width="55%"
                                  />
                                </div>
                              </td>
                              <td>2019-07-25</td>
                              <td>2019-08-17</td>
                              <td>
                                <div className="badge badge-info">Average</div>
                              </td>
                              <td>
                                <a href="#" className="btn btn-outline-primary">
                                  Detail
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <td className="p-0 text-center">
                                <div className="custom-checkbox custom-control">
                                  <input
                                    type="checkbox"
                                    data-checkboxes="mygroup"
                                    className="custom-control-input"
                                    id="checkbox-4"
                                  />
                                  <label
                                    htmlFor="checkbox-4"
                                    className="custom-control-label"
                                  >
                                    &nbsp;
                                  </label>
                                </div>
                              </td>
                              <td>Android App</td>
                              <td className="text-truncate">
                                <ul className="list-unstyled order-list m-b-0 m-b-0">
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-7.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Hero Gaur"
                                    />
                                  </li>
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-8.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Sarah Smith"
                                    />
                                  </li>
                                  <li className="avatar avatar-sm">
                                    <span className="badge badge-primary">
                                      +4
                                    </span>
                                  </li>
                                </ul>
                              </td>
                              <td className="align-middle">
                                <div className="progress-text">70%</div>
                                <div className="progress" data-height={6}>
                                  <div
                                    className="progress-bar"
                                    data-width="70%"
                                  />
                                </div>
                              </td>
                              <td>2018-04-15</td>
                              <td>2019-07-19</td>
                              <td>
                                <div className="badge badge-success">Low</div>
                              </td>
                              <td>
                                <a href="#" className="btn btn-outline-primary">
                                  Detail
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <td className="p-0 text-center">
                                <div className="custom-checkbox custom-control">
                                  <input
                                    type="checkbox"
                                    data-checkboxes="mygroup"
                                    className="custom-control-input"
                                    id="checkbox-5"
                                  />
                                  <label
                                    htmlFor="checkbox-5"
                                    className="custom-control-label"
                                  >
                                    &nbsp;
                                  </label>
                                </div>
                              </td>
                              <td>Logo Design</td>
                              <td className="text-truncate">
                                <ul className="list-unstyled order-list m-b-0 m-b-0">
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-9.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Wildan Ahdian"
                                    />
                                  </li>
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-10.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Hero Gaur"
                                    />
                                  </li>
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-2.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Sarah Smith"
                                    />
                                  </li>
                                  <li className="avatar avatar-sm">
                                    <span className="badge badge-primary">
                                      +2
                                    </span>
                                  </li>
                                </ul>
                              </td>
                              <td className="align-middle">
                                <div className="progress-text">45%</div>
                                <div className="progress" data-height={6}>
                                  <div
                                    className="progress-bar bg-cyan"
                                    data-width="45%"
                                  />
                                </div>
                              </td>
                              <td>2017-02-24</td>
                              <td>2018-09-06</td>
                              <td>
                                <div className="badge badge-danger">High</div>
                              </td>
                              <td>
                                <a href="#" className="btn btn-outline-primary">
                                  Detail
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <td className="p-0 text-center">
                                <div className="custom-checkbox custom-control">
                                  <input
                                    type="checkbox"
                                    data-checkboxes="mygroup"
                                    className="custom-control-input"
                                    id="checkbox-6"
                                  />
                                  <label
                                    htmlFor="checkbox-6"
                                    className="custom-control-label"
                                  >
                                    &nbsp;
                                  </label>
                                </div>
                              </td>
                              <td>Ecommerce website</td>
                              <td className="text-truncate">
                                <ul className="list-unstyled order-list m-b-0 m-b-0">
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-8.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Wildan Ahdian"
                                    />
                                  </li>
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-9.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Hero Gaur"
                                    />
                                  </li>
                                  <li className="team-member team-member-sm">
                                    <img
                                      className="rounded-circle"
                                      src="assets/img/users/user-10.png"
                                      alt="user"
                                      data-toggle="tooltip"
                                      title
                                      data-original-title="Sarah Smith"
                                    />
                                  </li>
                                  <li className="avatar avatar-sm">
                                    <span className="badge badge-primary">
                                      +4
                                    </span>
                                  </li>
                                </ul>
                              </td>
                              <td className="align-middle">
                                <div className="progress-text">30%</div>
                                <div className="progress" data-height={6}>
                                  <div
                                    className="progress-bar bg-orange"
                                    data-width="30%"
                                  />
                                </div>
                              </td>
                              <td>2018-01-20</td>
                              <td>2019-05-28</td>
                              <td>
                                <div className="badge badge-info">Average</div>
                              </td>
                              <td>
                                <a href="#" className="btn btn-outline-primary">
                                  Detail
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-12 col-xl-6">
                  {/* Support tickets */}
                  <div className="card">
                    <div className="card-header">
                      <h4>Support Ticket</h4>
                      <form className="card-header-form">
                        <input
                          type="text"
                          name="search"
                          className="form-control"
                          placeholder="Search"
                        />
                      </form>
                    </div>
                    <div className="card-body">
                      <div className="support-ticket media pb-1 mb-3">
                        <img
                          src="assets/img/users/user-1.png"
                          className="user-img mr-2"
                          alt
                        />
                        <div className="media-body ml-3">
                          <div className="badge badge-pill badge-success mb-1 float-right">
                            Feature
                          </div>
                          <span className="font-weight-bold">#89754</span>
                          <a href="javascript:void(0)">
                            Please add advance table
                          </a>
                          <p className="my-1">
                            Hi, can you please add new table for advan...
                          </p>
                          <small className="text-muted">
                            Created by{" "}
                            <span className="font-weight-bold font-13">
                             Hero Gaur
                            </span>
                            &nbsp;&nbsp; - 1 day ago
                          </small>
                        </div>
                      </div>
                      <div className="support-ticket media pb-1 mb-3">
                        <img
                          src="assets/img/users/user-2.png"
                          className="user-img mr-2"
                          alt
                        />
                        <div className="media-body ml-3">
                          <div className="badge badge-pill badge-warning mb-1 float-right">
                            Bug
                          </div>
                          <span className="font-weight-bold">#57854</span>
                          <a href="javascript:void(0)">
                            Select item not working
                          </a>
                          <p className="my-1">
                            please check select item in advance form not work...
                          </p>
                          <small className="text-muted">
                            Created by{" "}
                            <span className="font-weight-bold font-13">
                              Sarah Smith
                            </span>
                            &nbsp;&nbsp; - 2 day ago
                          </small>
                        </div>
                      </div>
                      <div className="support-ticket media pb-1 mb-3">
                        <img
                          src="assets/img/users/user-3.png"
                          className="user-img mr-2"
                          alt
                        />
                        <div className="media-body ml-3">
                          <div className="badge badge-pill badge-primary mb-1 float-right">
                            Query
                          </div>
                          <span className="font-weight-bold">#85784</span>
                          <a href="javascript:void(0)">
                            Are you provide template in Angular?
                          </a>
                          <p className="my-1">
                            can you provide template in latest angular 8.
                          </p>
                          <small className="text-muted">
                            Created by{" "}
                            <span className="font-weight-bold font-13">
                              Ashton Cox
                            </span>
                            &nbsp;&nbsp; -2 day ago
                          </small>
                        </div>
                      </div>
                      <div className="support-ticket media pb-1 mb-3">
                        <img
                          src="assets/img/users/user-6.png"
                          className="user-img mr-2"
                          alt
                        />
                        <div className="media-body ml-3">
                          <div className="badge badge-pill badge-info mb-1 float-right">
                            Enhancement
                          </div>
                          <span className="font-weight-bold">#25874</span>
                          <a href="javascript:void(0)">
                            About template page load speed
                          </a>
                          <p className="my-1">
                            Hi, Hero, can you work on increase page speed of
                            template...
                          </p>
                          <small className="text-muted">
                            Created by{" "}
                            <span className="font-weight-bold font-13">
                              Hasan Basri
                            </span>
                            &nbsp;&nbsp; -3 day ago
                          </small>
                        </div>
                      </div>
                    </div>
                    <a
                      href="javascript:void(0)"
                      className="card-footer card-link text-center small "
                    >
                      View All
                    </a>
                  </div>
                  {/* Support tickets */}
                </div>
                <div className="col-md-6 col-lg-12 col-xl-6">
                  <div className="card">
                    <div className="card-header">
                      <h4>Projects Payments</h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Client Name</th>
                              <th>Date</th>
                              <th>Payment Method</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>Hero</td>
                              <td>11-08-2018</td>
                              <td>NEFT</td>
                              <td>$258</td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>Cara Stevens</td>
                              <td>15-07-2018</td>
                              <td>PayPal</td>
                              <td>$125</td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>Airi Satou</td>
                              <td>25-08-2018</td>
                              <td>RTGS</td>
                              <td>$287</td>
                            </tr>
                            <tr>
                              <td>4</td>
                              <td>Angelica Ramos</td>
                              <td>01-05-2018</td>
                              <td>CASH</td>
                              <td>$170</td>
                            </tr>
                            <tr>
                              <td>5</td>
                              <td>Ashton Cox</td>
                              <td>18-04-2018</td>
                              <td>NEFT</td>
                              <td>$970</td>
                            </tr>
                            <tr>
                              <td>6</td>
                              <td>Hero Gaur</td>
                              <td>22-11-2018</td>
                              <td>PayPal</td>
                              <td>$854</td>
                            </tr>
                            <tr>
                              <td>7</td>
                              <td>Hasan Basri</td>
                              <td>07-09-2018</td>
                              <td>Cash</td>
                              <td>$128</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="settingSidebar">
              <a href="javascript:void(0)" className="settingPanelToggle">
                {" "}
                <i className="fa fa-spin fa-cog" />
              </a>
              <div className="settingSidebar-body ps-container ps-theme-default">
                <div className=" fade show active">
                  <div className="setting-panel-header">Setting Panel</div>
                  <div className="p-15 border-bottom">
                    <h6 className="font-medium m-b-10">Select Layout</h6>
                    <div className="selectgroup layout-color w-50">
                      <label className="selectgroup-item">
                        <input
                          type="radio"
                          name="value"
                          defaultValue={1}
                          className="selectgroup-input-radio select-layout"
                          defaultChecked
                        />
                        <span className="selectgroup-button">Light</span>
                      </label>
                      <label className="selectgroup-item">
                        <input
                          type="radio"
                          name="value"
                          defaultValue={2}
                          className="selectgroup-input-radio select-layout"
                        />
                        <span className="selectgroup-button">Dark</span>
                      </label>
                    </div>
                  </div>
                  <div className="p-15 border-bottom">
                    <h6 className="font-medium m-b-10">Sidebar Color</h6>
                    <div className="selectgroup selectgroup-pills sidebar-color">
                      <label className="selectgroup-item">
                        <input
                          type="radio"
                          name="icon-input"
                          defaultValue={1}
                          className="selectgroup-input select-sidebar"
                        />
                        <span
                          className="selectgroup-button selectgroup-button-icon"
                          data-toggle="tooltip"
                          data-original-title="Light Sidebar"
                        >
                          <i className="fas fa-sun" />
                        </span>
                      </label>
                      <label className="selectgroup-item">
                        <input
                          type="radio"
                          name="icon-input"
                          defaultValue={2}
                          className="selectgroup-input select-sidebar"
                          defaultChecked
                        />
                        <span
                          className="selectgroup-button selectgroup-button-icon"
                          data-toggle="tooltip"
                          data-original-title="Dark Sidebar"
                        >
                          <i className="fas fa-moon" />
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="p-15 border-bottom">
                    <h6 className="font-medium m-b-10">Color Theme</h6>
                    <div className="theme-setting-options">
                      <ul className="choose-theme list-unstyled mb-0">
                        <li title="white" className="active">
                          <div className="white" />
                        </li>
                        <li title="cyan">
                          <div className="cyan" />
                        </li>
                        <li title="black">
                          <div className="black" />
                        </li>
                        <li title="purple">
                          <div className="purple" />
                        </li>
                        <li title="orange">
                          <div className="orange" />
                        </li>
                        <li title="green">
                          <div className="green" />
                        </li>
                        <li title="red">
                          <div className="red" />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="p-15 border-bottom">
                    <div className="theme-setting-options">
                      <label className="m-b-0">
                        <input
                          type="checkbox"
                          name="custom-switch-checkbox"
                          className="custom-switch-input"
                          id="mini_sidebar_setting"
                        />
                        <span className="custom-switch-indicator" />
                        <span className="control-label p-l-10">
                          Mini Sidebar
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="p-15 border-bottom">
                    <div className="theme-setting-options">
                      <label className="m-b-0">
                        <input
                          type="checkbox"
                          name="custom-switch-checkbox"
                          className="custom-switch-input"
                          id="sticky_header_setting"
                        />
                        <span className="custom-switch-indicator" />
                        <span className="control-label p-l-10">
                          Sticky Header
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="mt-4 mb-4 p-3 align-center rt-sidebar-last-ele">
                    <a
                      href="#"
                      className="btn btn-icon icon-left btn-primary btn-restore-theme"
                    >
                      <i className="fas fa-undo" /> Restore Default
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="main-footer">
            <div className="footer-left">
              <a href="templateshub.net">Templateshub</a>
            </div>
            <div className="footer-right"></div>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default Profile;
